import { match as e } from "ts-pattern";
import * as t from "date-fns";
import { tz as n, tz as r } from "@date-fns/tz";
import i from "lodash/fp/equals.js";
import { enGB as a } from "date-fns/locale";
//#region src/dates/dateFnsPassthrough.ts
var o = t.isBefore, s = t.isAfter, c = t.isEqual, l = t.isValid, u = (e, n = {}) => t.getDate(e, {
	...n,
	in: n.in ?? r("UTC")
}), d = (e, n = {}) => t.getMonth(e, {
	...n,
	in: n.in ?? r("UTC")
}), f = (e, n = {}) => t.getYear(e, {
	...n,
	in: n.in ?? r("UTC")
}), p = (e, n = {}) => t.endOfDay(e, {
	...n,
	in: n.in ?? r("UTC")
}), ee = (e, n = {}) => t.lastDayOfMonth(e, {
	...n,
	in: n.in ?? r("UTC")
}), m = (e, n = {}) => t.getDaysInMonth(e, {
	...n,
	in: n.in ?? r("UTC")
}), h = (e, n = {}) => t.getDaysInYear(e, {
	...n,
	in: n.in ?? r("UTC")
}), g = (e, n = {}) => t.startOfMonth(e, {
	...n,
	in: n.in ?? r("UTC")
}), _ = (e, n = {}) => t.startOfYear(e, {
	...n,
	in: n.in ?? r("UTC")
}), v = (e, n = {}) => t.endOfYear(e, {
	...n,
	in: n.in ?? r("UTC")
}), y = (e, n = {}) => t.startOfDay(e, {
	...n,
	in: n.in ?? r("UTC")
}), b = (e, n, i, a = {}) => t.parse(e, n, i, {
	...a,
	in: a.in ?? r("UTC")
}), te = (e, n = {}) => t.parseISO(e, {
	...n,
	in: n.in ?? r("UTC")
}), x = (e, n, i = {}) => t.add(e, n, {
	...i,
	in: i.in ?? r("UTC")
}), ne = (e, n, i = {}) => t.sub(e, n, {
	...i,
	in: i.in ?? r("UTC")
}), re = (e, n, i = {}) => t.setDate(e, n, {
	...i,
	in: i.in ?? r("UTC")
}), ie = (e, n, i = {}) => t.differenceInSeconds(e, n, {
	...i,
	in: i.in ?? r("UTC")
}), ae = (e, n, i = {}) => t.differenceInMinutes(e, n, {
	...i,
	in: i.in ?? r("UTC")
}), S = (e, n, i = {}) => t.differenceInHours(e, n, {
	...i,
	in: i.in ?? r("UTC")
}), C = (e, n, i = {}) => t.differenceInDays(e, n, {
	...i,
	in: i.in ?? r("UTC")
}), w = (e, n, i = {}) => t.differenceInCalendarDays(e, n, {
	...i,
	in: i.in ?? r("UTC")
}), T = (e, n, i = {}) => t.format(e, n, {
	...i,
	in: i.in ?? r("UTC")
}), E = (e, n = {}) => t.formatISO(e, {
	...n,
	in: n.in ?? r("UTC")
}), D = (e, n = {}) => t.formatDistanceToNow(e, {
	...n,
	in: n.in ?? r("UTC")
}), O = (e, n, i = {}) => t.interval(e, n, {
	...i,
	in: i.in ?? r("UTC")
}), k = (e, n = {}) => t.intervalToDuration(e, {
	...n,
	in: n.in ?? r("UTC")
}), A = (e, n = {}) => t.isFirstDayOfMonth(e, {
	...n,
	in: n.in ?? r("UTC")
}), j = (e, n = {}) => t.isLastDayOfMonth(e, {
	...n,
	in: n.in ?? r("UTC")
}), M = (e, n, i = {}) => t.isSameDay(e, n, {
	...i,
	in: i.in ?? r("UTC")
}), N = (e, n, i = {}) => t.formatDistanceStrict(e, n, {
	...i,
	in: i.in ?? r("UTC")
}), P = (e, n = {}) => t.endOfMonth(e, {
	...n,
	in: n.in ?? r("UTC")
}), F = (e, n, i = {}) => t.set(e, n, {
	...i,
	in: i.in ?? r("UTC")
}), I = (e, n = {}) => t.eachDayOfInterval(e, {
	...n,
	in: n.in ?? r("UTC")
}), L = (e, n = {}) => t.eachMonthOfInterval(e, {
	...n,
	in: n.in ?? r("UTC")
}), R = (e, n = {}) => t.eachWeekOfInterval(e, {
	...n,
	in: n.in ?? r("UTC")
}), z = (e, n = {}) => t.startOfQuarter(e, {
	...n,
	in: n.in ?? r("UTC")
}), B = (e, n = {}) => t.endOfQuarter(e, {
	...n,
	in: n.in ?? r("UTC")
}), V = (e, { localDate: t = !0 } = {}) => (n) => {
	if (!e || !n) return !1;
	try {
		return new Date(Date.parse(e + (t ? "T00:00:00.000Z" : ""))).getFullYear() === new Date(Date.parse(n + (t ? "T00:00:00.000Z" : ""))).getFullYear();
	} catch {
		return !1;
	}
}, oe = (e, t) => {
	let n = /* @__PURE__ */ new Date(0);
	return k({
		start: n,
		end: x(x(n, e), t)
	});
};
function H(e) {
	let t = Math.floor((e.months ?? 0) / 12);
	return {
		years: (e.years ?? 0) + t,
		months: (e.months ?? 0) % 12,
		days: e.days ?? 0
	};
}
function U(e, t) {
	return i(H(e), H(t));
}
var W = (e, t) => {
	let n = /* @__PURE__ */ new Date(0);
	return x(n, e) < x(n, t);
}, G = (t, n) => {
	let r = t.getUTCDate().toString().padStart(2, "0"), i = (t.getUTCMonth() + 1).toString().padStart(2, "0"), a = t.getUTCFullYear();
	return e(n).with("start", () => `${a}-${i}-${r}T00:00:00.000Z`).with("end", () => `${a}-${i}-${r}T23:59:59.999Z`).exhaustive();
}, K = (e, t = (/* @__PURE__ */ new Date()).getFullYear()) => {
	switch (e) {
		case 1: return z(new Date(t, 0, 5));
		case 2: return z(new Date(t, 3, 5));
		case 3: return z(new Date(t, 6, 5));
		case 4: return z(new Date(t, 9, 5));
		default: throw Error(`Invalid quarter: ${e}`);
	}
}, q = (e, t = (/* @__PURE__ */ new Date()).getFullYear()) => {
	switch (e) {
		case 1: return B(new Date(t, 2, 5));
		case 2: return B(new Date(t, 5, 5));
		case 3: return B(new Date(t, 8, 5));
		case 4: return B(new Date(t, 11, 5));
		default: throw Error(`Invalid quarter: ${e}`);
	}
}, se = (e = (/* @__PURE__ */ new Date()).getFullYear()) => {
	let t = Math.floor((/* @__PURE__ */ new Date()).getMonth() / 3) + 1;
	switch (t) {
		case 1: {
			let t = e - 1;
			return [K(4, t), q(4, t)];
		}
		default: return [K(t - 1), q(t - 1)];
	}
}, J = (e) => {
	let t = e ? new Date(e) : /* @__PURE__ */ new Date(), n = Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds());
	return new Date(n);
}, ce = (e) => {
	try {
		let t = J(e);
		return isNaN(t.getTime()) ? void 0 : t;
	} catch {
		return;
	}
}, le = {
	toDate: (e) => (t) => {
		if (e) return x(e, t);
	},
	toDuration: (e) => (t) => {
		if (!e || !t) return;
		let n = k({
			start: e,
			end: t
		});
		return c(x(e, {
			years: n.years ?? 0,
			months: (n.months ?? 0) + 1,
			days: -1
		}), t) ? (n.months ?? 0) + 1 === 12 ? {
			years: (n.years ?? 0) + 1,
			months: 0,
			days: -1
		} : {
			years: n.years ?? 0,
			months: (n.months ?? 0) + 1,
			days: -1
		} : {
			years: n.years ?? 0,
			months: n.months ?? 0,
			days: n.days ?? 0
		};
	}
}, ue = {
	lessThanXSeconds: {
		one: "1s",
		other: "1s"
	},
	xSeconds: {
		one: "1s",
		other: "{{count}}s"
	},
	halfAMinute: "30s",
	lessThanXMinutes: {
		one: "just now",
		other: "{{count}}m"
	},
	xMinutes: {
		one: "1m",
		other: "{{count}}m"
	},
	aboutXHours: {
		one: "1h",
		other: "{{count}}h"
	},
	xHours: {
		one: "1h",
		other: "{{count}}h"
	},
	xDays: {
		one: "1d",
		other: "{{count}}d"
	},
	aboutXWeeks: {
		one: "1w",
		other: "{{count}}w"
	},
	xWeeks: {
		one: "1w",
		other: "{{count}}w"
	},
	aboutXMonths: {
		one: "1mth",
		other: "{{count}}mo"
	},
	xMonths: {
		one: "1mth",
		other: "{{count}}mo"
	},
	aboutXYears: {
		one: "1y",
		other: "{{count}}y"
	},
	xYears: {
		one: "1y",
		other: "{{count}}y"
	},
	overXYears: {
		one: "1y",
		other: "{{count}}y"
	},
	almostXYears: {
		one: "1y",
		other: "{{count}}y"
	}
}, de = (e, t, n) => {
	let r, i = ue[e];
	return r = typeof i == "string" ? i : t === 1 ? i.one : i.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : e === "lessThanXMinutes" && t === 1 ? r : r + " ago" : r;
}, fe = { enGb: {
	...a,
	code: "en-GB-Custom",
	formatDistance: de
} }, pe = ({ from: e, to: t, inTimezone: r = n("UTC"), formatStr: { year: i = "yyyy", month: a = "MMM", day: o = "d" } = {}, separator: s = "to" }) => {
	if (!l(e) || !l(t)) return "Invalid date range";
	let u = `${o} ${a} ${i}`, d = `${o} ${a}`;
	return c(e, t) ? T(e, u, { in: r }) : f(e) === f(t) ? `${T(e, d, { in: r })} ${s} ${T(t, u, { in: r })}` : `${T(e, u, { in: r })} ${s} ${T(t, u, { in: r })}`;
}, Y = (e, n) => {
	let { fallback: r, ...i } = n ?? {};
	return (e == null ? "" : t.formatDuration(e, i)) || r || "";
}, X = 1e3, Z = 60 * X, me = 60 * Z, Q = (e) => {
	if (e) return b(e, "yyyy-MM-dd", /* @__PURE__ */ new Date());
}, $ = (e) => e ? T(e, "yyyy-MM-dd") : "", he = {
	fromApi: Q,
	toApi: $
};
//#endregion
export { ee as $, R as A, m as B, w as C, ie as D, ae as E, T as F, k as G, d as H, N as I, c as J, s as K, D as L, P as M, B as N, I as O, v as P, l as Q, E as R, x as S, S as T, f as U, h as V, O as W, j as X, A as Y, M as Z, G as _, Z as a, g as at, K as b, pe as c, ne as ct, J as d, b as et, oe as f, W as g, q as h, me as i, y as it, p as j, L as k, fe as l, r as lt, U as m, $ as n, F as nt, X as o, z as ot, V as p, o as q, Q as r, re as rt, Y as s, _ as st, he as t, te as tt, le as u, H as v, C as w, ce as x, se as y, u as z };

//# sourceMappingURL=dates-CZDXVurS.js.map